import type { JSX } from "react";
import { cn } from "./cn";

export interface UnreadCountProps {
  /** Unread count to display */
  readonly count: number;
  /** Extra className */
  readonly className?: string;
}

/**
 * A circular unread-message count badge.
 */
export function UnreadCount({ count, className }: UnreadCountProps): JSX.Element {
  return (
    <span
      className={cn(
        "bg-accent text-white text-[10px] rounded-full w-[18px] h-[18px] inline-flex items-center justify-center shrink-0",
        className,
      )}
    >
      {count}
    </span>
  );
}
